import { render, staticRenderFns } from "./TipoCompromissoModal.vue?vue&type=template&id=4d5bd79a"
import script from "./TipoCompromissoModal.vue?vue&type=script&lang=js"
export * from "./TipoCompromissoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports